 

import { DefaultAttributes } from './types';

export const defaultAttributesRequiredOverride: DefaultAttributes[] = [
    DefaultAttributes.NAME,
    DefaultAttributes.DEAL_TYPE,
    DefaultAttributes.CONSTRUCTION_TYPE,
    DefaultAttributes.ADDRESS,
    DefaultAttributes.CITY,
    DefaultAttributes.COUNTY,
    DefaultAttributes.STATE,
    DefaultAttributes.ZIP_CODE,
];

export const enum ConstructionTypeIds {
    GroundUp = '659d5104-3b40-45ea-b788-893a070dcf1f',
}

export const enum AssetTypeIds {
    RentalApartment = '2dbd4748-8bf0-4fd4-9c44-191101f5e9c7',
}

// Fake address pre-populated for user's first deal
export const FIRST_DEAL_DEFAULTS = {
    name: 'My First Deal',
    address: '123 Sesame Street',
    city: 'New York',
    county: 'New York County',
    state: 'New York',
    zipCode: '10001',
} as const;
